import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import NoGamesFoundImg from '../../assets/no_games_img.png';
import { DEFAULT_LANGUAGE } from '../../i18n/constants';
import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';
import { I18Text } from '../i18Next/I18Text';

import { GameCard } from './GameCard';
import styles from './NoGamesFound.module.scss';

export const NoGamesFound = observer(() => {
  const { recentlyPlayedStore } = useStores();
  const { t } = useTranslation();
  const gameLabelFF = useFlag('game_labels_feat', false);

  const { recentlyPlayedGames } = recentlyPlayedStore;

  return (
    <div className={styles.noGamesFound}>
      <img alt="no games found" className={styles.noGamesFoundImg} src={NoGamesFoundImg} />
      <div className={styles.textBlock} data-testid="no-games-found-text">
        <h2 className={styles.label}>{t('games.reelsCameUpEmpty')}</h2>
        {recentlyPlayedGames?.length ? (
          <>
            <I18Text className={styles.text} i18nKey="games.tryDifferentSearch" />
          </>
        ) : (
          <span className={styles.text}>{t('games.tryDifferentSearchOrExplore')}</span>
        )}
      </div>
      {recentlyPlayedGames?.length ? (
        <>
          <div className={styles.categoryBlock}>
            <h2 className={styles.categoryName}>{t('games.recentlyPlayed')}</h2>
          </div>
          <div className={styles.gamesBlock}>
            {recentlyPlayedGames.map((game) => (
              <GameCard
                key={`${game.identifier}::${game.masterCasinoGameId}`}
                carousel
                game={game}
                gameLabelFF={gameLabelFF}
                onboarding={false}
                rowName={t('games.recentlyPlayed', { lng: DEFAULT_LANGUAGE })}
              />
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
});
